import React, { useState } from 'react';

import { Box, Button, Grid, Tooltip } from '@material-ui/core';
import { CustomVideoPlayer, DocumentFileIcon, Typography } from '@room-match/shared-ui-components';
import ImageGallery from 'shared/components/ImageGallery/ImageGallery';
import LinkItem from 'shared/components/LinkItem/LinkItem';
import useWindowDimensions from 'shared/hooks/useWindowDimenstion';
import { IAuditionAttributes } from 'shared/interfaces/IAudition';
import { ISidesMedia } from 'shared/interfaces/IMedia';
import {
  FileName,
  RoleVideoWrapper,
  TextGreyColor,
  TextSwitchColor,
  useStyles,
  VideoCont,
  VideoMainCont,
} from './CompanyInformation.styles';
import { CustomTypography } from 'shared/elements/CustomTypography';
interface Props {
  auditionData?: IAuditionAttributes;
  union?: string | null;
  generalNotes: string | null;
}

const CompanyInformation: React.FC<Props> = ({ auditionData, union, generalNotes }) => {
  const classes = useStyles();
  const { width } = useWindowDimensions();
  const [imageIndex, setimageIndex] = useState<number>(0);
  const [showImageModal, setshowImageModal] = useState<boolean>(false);

  const roleData = auditionData?.casting_role.data.attributes;
  const selftapesReq = roleData?.self_tapes_requirements;
  const selftapesDirections = roleData?.self_tapes_directions;

  const renderPhotos = () => {
    const img = roleData?.photos.data.map((image: ISidesMedia, idx: number) => {
      return {
        id: image.attributes.id,
        src: image.attributes.modified_attachment || image.attributes.attachment,
        height: image.attributes.medium.data.attributes.file_height,
        width: image.attributes.medium.data.attributes.file_width,
        idx: idx + 1,
      };
    });

    return img;
  };

  const renderedImages = renderPhotos();

  const handleClick = (idx: number) => {
    setimageIndex(idx);
    setshowImageModal(true);
  };

  return (
    <Grid className={classes.root}>
      {/* <Select
          variant="outlined"
          fullWidth
          data={[{ key: 'Smith Agency, Los Angeles', value: 'Smith Agency, Los Angeles' }]}
          value="Smith Agency, Los Angeles"
          IconComponent={SelectArrowDownIcon}
          name="representation_status"
        /> */}

      {/* <Select
          variant="outlined"
          fullWidth
          data={[{ key: 'Smith Agency, Los Angeles', value: 'Smith Agency, Los Angeles' }]}
          value="Smith Agency, Los Angeles"
          IconComponent={SelectArrowDownIcon}
          name="representation_status"
        /> */}

      <Grid item className={classes.textBlock}>
        <CustomTypography className={`${classes.textLabel} ${classes.yellow}`}>General Notes:</CustomTypography>
        {/* video / descripyion in pharagraph
          video / descripyion in pharagraph
          role video */}
        <CustomTypography style={{ textAlign: 'justify', marginLeft: 10, whiteSpace: 'break-spaces' }}>
          {generalNotes || '-'}
        </CustomTypography>
      </Grid>

      <Grid item className={classes.textBlock}>
        <CustomTypography className={`${classes.textLabel} ${classes.yellow}`}>Directions:</CustomTypography>
        {/* video / descripyion in pharagraph
          video / descripyion in pharagraph
          role video */}
        <CustomTypography style={{ textAlign: 'justify', marginLeft: 10, whiteSpace: 'break-spaces' }}>
          {roleData?.self_tapes_requirements?.selections || '-'}
        </CustomTypography>
      </Grid>

      <VideoMainCont>
        {selftapesDirections && (
          <React.Fragment>
            {selftapesDirections?.map((m) => (
              <RoleVideoWrapper>
                <VideoCont>
                  <CustomVideoPlayer
                    isSmall
                    classes={{ root: 'profile-video-item', videoPlayer: '', icon: '' }}
                    url={m.media?.attachment ? m.media.attachment : ''}
                    // thumbnail={thumbnail}
                  />
                </VideoCont>
                {/* <ReactPlayer url={m.media?.attachment ? m.media.attachment : ''} light playing /> */}
                <Typography style={{ textAlign: 'justify', marginLeft: 10 }} fontSize={14}>
                  {m.description}
                </Typography>
                {/* <Typography style={{ textAlign: 'justify', marginLeft: 10 }} fontSize={14}>
                  {m.media?.duration}
                </Typography> */}
              </RoleVideoWrapper>
            ))}

            {/* <Typography>{roleData?.talent_description}</Typography> */}
          </React.Fragment>
        )}
      </VideoMainCont>
      {/* <Grid item className={classes.textBlock}>
          <Typography color="darkGrey">Representation:</Typography>
          <Typography style={{ marginLeft: 10 }}>
            {auditionData?.profile.data.attributes.representation_type === 'Non-Represented'
              ? 'Non-Represented'
              : auditionData?.profile.data.attributes.agency_name}
          </Typography>
        </Grid> */}
      {roleData?.talent_note ? (
        <Grid item className={classes.textBlock}>
          <Typography className={`${classes.textLabel} ${classes.yellow}`}>Casting's Message:</Typography>
          {/* video / descripyion in pharagraph
           video / descripyion in pharagraph
           role video */}
          <CustomTypography style={{ textAlign: 'justify', marginLeft: 10, whiteSpace: 'break-spaces' }}>
            {roleData?.talent_note || '-'}
          </CustomTypography>
        </Grid>
      ) : (
        <React.Fragment />
      )}
      <CustomTypography fontWeight={700} color="primary" style={{ marginBottom: 10 }}>
        Role Information:
      </CustomTypography>
      <Grid item className={classes.textBlock}>
        <CustomTypography fontWeight={700}>Wardrobe Notes:</CustomTypography>
        <CustomTypography style={{ marginLeft: 10 }}>{roleData?.wardrobe}</CustomTypography>
      </Grid>
      <Grid item className={classes.textBlock}>
        <CustomTypography fontWeight={700}>Role Name:</CustomTypography>
        <CustomTypography style={{ marginLeft: 10 }}>{roleData?.name}</CustomTypography>
      </Grid>

      <Grid item className={classes.textBlock}>
        <CustomTypography fontWeight={700}>Role Gender:</CustomTypography>
        <CustomTypography style={{ marginLeft: 10 }}>
          {roleData?.genders?.length
            ? roleData?.genders.map((s, i) => `${i === roleData.genders?.length - 1 ? `${s}` : `${s}, `}`)
            : '-'}
        </CustomTypography>
      </Grid>

      <Grid item className={classes.textBlock}>
        <CustomTypography fontWeight={700}>Age Range:</CustomTypography>
        <CustomTypography style={{ marginLeft: 10 }}>
          {`${'\n'}`} {roleData?.age_range_from}-{roleData?.age_range_to} {`${'\n'}`}
        </CustomTypography>
      </Grid>
      <Grid item className={classes.textBlock}>
        <CustomTypography fontWeight={700}>Role Type:</CustomTypography>
        <CustomTypography style={{ marginLeft: 10 }}> {roleData?.principal_role_type || '-'}</CustomTypography>
      </Grid>

      <Grid item className={classes.textBlock}>
        <CustomTypography fontWeight={700}>Union:</CustomTypography>
        <CustomTypography style={{ marginLeft: 10 }}>{union || '-'}</CustomTypography>
      </Grid>

      <Grid item className={classes.textBlock}>
        <CustomTypography className={classes.yellow} color="primary">
          Media Required:
        </CustomTypography>
        <Box component="div" className={classes.mediaList} style={{ marginLeft: 10 }}>
          {selftapesReq?.audition_selfie && <CustomTypography>{`1x Image (Headshot)`}</CustomTypography>}
          {selftapesReq?.full_body && <CustomTypography>{`1x Image (Full Body)`}</CustomTypography>}
          {selftapesReq?.slate && <CustomTypography>{`1x Slate`}</CustomTypography>}
          {selftapesReq?.files?.length ? (
            <CustomTypography>{`${selftapesReq.files?.length}x ${
              selftapesReq.files?.length > 1 ? 'Files' : 'File'
            }`}</CustomTypography>
          ) : (
            ''
          )}
          {selftapesReq?.other_images?.length ? (
            <CustomTypography>{`${selftapesReq.other_images?.length}x Other ${
              selftapesReq.other_images?.length > 1 ? 'Images' : 'Image'
            }`}</CustomTypography>
          ) : (
            ''
          )}
          {selftapesReq?.audio?.length ? (
            <CustomTypography>{`${selftapesReq.audio?.length}x ${
              selftapesReq.audio?.length > 1 ? 'Audios' : 'Audio'
            }`}</CustomTypography>
          ) : (
            ''
          )}
          {selftapesReq?.video?.length ? (
            <CustomTypography>{`${selftapesReq.video?.length}x ${
              selftapesReq.video?.length > 1 ? 'Videos' : 'Video'
            }`}</CustomTypography>
          ) : (
            ''
          )}
          {roleData?.sides.data?.length ? (
            <CustomTypography>{`(${roleData.sides.data?.length}x sides/scripts attached)`}</CustomTypography>
          ) : (
            ''
          )}
        </Box>
      </Grid>
      {roleData?.photos.data?.length || roleData?.sides.data?.length ? (
        <Grid item className={classes.textBlock}>
          <CustomTypography fontWeight={600} color="primary">
            Ref Images/Files:
          </CustomTypography>
          {roleData?.photos.data?.length ? (
            <div>
              {roleData?.photos.data?.map((m, idx) => (
                <img
                  className={classes.img}
                  src={`${m.attributes.attachment}`}
                  // thumbnail={thumbnail}
                  onClick={() => handleClick(idx + 1)}
                />
              ))}
            </div>
          ) : (
            <React.Fragment />
          )}
          {roleData?.sides.data?.length ? (
            <Grid item className={classes.fileList}>
              {roleData?.sides.data.map((i) => (
                <Tooltip title={i.attributes.medium.data.attributes.file_name}>
                  <Button
                    className={classes.fileItem}
                    onClick={() => window.open(`${i.attributes.attachment}`, '_blank')}
                  >
                    <DocumentFileIcon />
                    <FileName style={{ flex: 1 }}>{`${i.attributes.medium.data.attributes.file_name}`}</FileName>
                    {/* <FileName>.{`${i.attributes.medium.data.attributes.file_name.split('.')[1]}`}</FileName> */}
                  </Button>
                </Tooltip>
              ))}
            </Grid>
          ) : (
            <React.Fragment />
          )}
        </Grid>
      ) : (
        <React.Fragment />
      )}
      <Grid item className={classes.fileList}>
        {roleData?.reference_urls?.length ? (
          roleData?.reference_urls.map((link, idx) => <LinkItem key={idx} url={link} />)
        ) : (
          <React.Fragment />
        )}
      </Grid>
      <ImageGallery
        fullScreen={width < 960}
        current={imageIndex - 1}
        images={renderedImages}
        thumbnails={renderedImages}
        open={showImageModal}
        onClose={() => setshowImageModal(false)}
      />
    </Grid>
  );
};

export default CompanyInformation;
